/***
 * 对象属性值拷贝
 * @param source
 * @param target
 */
const objCopy = (source, target) => {
  for (let key in source) {
    let sourceValue = source[key]
    if (target.hasOwnProperty(key)) {
      target[key] = sourceValue
    }
  }
}

export {objCopy}
